import * as types from "./actionTypes";
import referentieApi from "../api/referentieApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";

// ----------------------------------------------------------------------------
function referencesLoaded(references){
	return {
		type: types.REFERENCES_LOADED,
		body: references
	};
	
}

export function loadReferences() {
	return function (dispatch) {
		dispatch(ajax.started());
		return referentieApi.getAll()
			.then((response) => {
				dispatch(ajax.ended());
				dispatch(referencesLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
